import { ChangeDetectionStrategy, Component, inject, OnInit } from "@angular/core";
import { PwaService } from "../pwa-install-prompt/pwa.service";

@Component({
	selector: "app-install",
	templateUrl: "./install.component.html",
	styleUrls: ["./install.component.css"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class InstallComponent implements OnInit {
	private pwaService: PwaService = inject(PwaService);

	mobileType: string;

	ngOnInit(): void {
		this.mobileType = this.pwaService.mobileType;
	}

	public installPwa(): void {
		this.pwaService.promptEvent.prompt();
	}
}
